// export const BASE_URL = 
//   process.env.NODE_ENV === 'development' ? 
//     'http://localhost:5000' : ''; 
// Abobe might work ok if no proxy (URL? or "proxy" in package.json) was being used

export const BASE_URL = "";
export const DRIVES_URL = "/api/drives";
export const BENCHMARKS_URL = "/api/benchmarks";
export const USERS_URL = "/api/users";
export const BLOG_URL = "/api/blog";
// The signed-in user's own resources (profile, benchmarks, drives, systems, blogs)
export const ME_URL = "/api/me";